// Pharmacy branding utilities - colors, abbreviations, and logo URLs
// Uses Clearbit Logo API for high-quality logos with fallback to colored badges

// Pharmacy logo URLs - using Clearbit API and direct URLs
const PHARMACY_LOGOS = {
  'cvs': 'https://logo.clearbit.com/cvs.com',
  'cvs pharmacy': 'https://logo.clearbit.com/cvs.com',
  'walgreens': 'https://logo.clearbit.com/walgreens.com',
  'walmart': 'https://logo.clearbit.com/walmart.com',
  'rite aid': 'https://logo.clearbit.com/riteaid.com',
  'rite aid/walgreens': 'https://logo.clearbit.com/riteaid.com',
  'kroger': 'https://logo.clearbit.com/kroger.com',
  'costco': 'https://logo.clearbit.com/costco.com',
  'target': 'https://logo.clearbit.com/target.com',
  'publix': 'https://logo.clearbit.com/publix.com',
  'safeway': 'https://logo.clearbit.com/safeway.com',
  'albertsons': 'https://logo.clearbit.com/albertsons.com',
  'food lion': 'https://logo.clearbit.com/foodlion.com',
  'giant': 'https://logo.clearbit.com/giantfood.com',
  'giant eagle': 'https://logo.clearbit.com/gianteagle.com',
  'h-e-b': 'https://logo.clearbit.com/heb.com',
  'heb': 'https://logo.clearbit.com/heb.com',
  'meijer': 'https://logo.clearbit.com/meijer.com',
  'wegmans': 'https://logo.clearbit.com/wegmans.com',
  'sam\'s club': 'https://logo.clearbit.com/samsclub.com',
  'sams club': 'https://logo.clearbit.com/samsclub.com',
  'amazon pharmacy': 'https://logo.clearbit.com/amazon.com',
  'amazon': 'https://logo.clearbit.com/amazon.com',
  'harris teeter': 'https://logo.clearbit.com/harristeeter.com',
  'winn-dixie': 'https://logo.clearbit.com/winndixie.com',
  'winn dixie': 'https://logo.clearbit.com/winndixie.com',
  'fred meyer': 'https://logo.clearbit.com/fredmeyer.com',
  'shoprite': 'https://logo.clearbit.com/shoprite.com',
  'hannaford': 'https://logo.clearbit.com/hannaford.com',
  'stop & shop': 'https://logo.clearbit.com/stopandshop.com',
  'stop and shop': 'https://logo.clearbit.com/stopandshop.com',
  'hy-vee': 'https://logo.clearbit.com/hy-vee.com',
  'hyvee': 'https://logo.clearbit.com/hy-vee.com',
  'price chopper': 'https://logo.clearbit.com/pricechopper.com',
  'aldi': 'https://logo.clearbit.com/aldi.us',
  'duane reade': 'https://logo.clearbit.com/walgreens.com',
  'acme': 'https://logo.clearbit.com/acmemarkets.com',
  'vons': 'https://logo.clearbit.com/vons.com',
  'jewel-osco': 'https://logo.clearbit.com/jewelosco.com',
  'tom thumb': 'https://logo.clearbit.com/tomthumb.com',
  'randalls': 'https://logo.clearbit.com/randalls.com',
  'king soopers': 'https://logo.clearbit.com/kingsoopers.com',
  'fry\'s': 'https://logo.clearbit.com/frysfood.com',
  'frys': 'https://logo.clearbit.com/frysfood.com',
  'ralphs': 'https://logo.clearbit.com/ralphs.com',
  'smith\'s': 'https://logo.clearbit.com/smithsfoodanddrug.com',
  'smiths': 'https://logo.clearbit.com/smithsfoodanddrug.com',
  'qfc': 'https://logo.clearbit.com/qfc.com',
  'dillons': 'https://logo.clearbit.com/dillons.com',
  'genoa': 'https://logo.clearbit.com/genoahealthcare.com',
  'good neighbor': 'https://logo.clearbit.com/gnp.com',
  'health mart': 'https://logo.clearbit.com/healthmart.com',
  'medicine shoppe': 'https://logo.clearbit.com/medicineshoppe.com',
  'kinney': 'https://logo.clearbit.com/kinneydrugs.com',
  'bi-lo': 'https://logo.clearbit.com/bi-lo.com',
  'bilo': 'https://logo.clearbit.com/bi-lo.com',
  'ingles': 'https://logo.clearbit.com/ingles-markets.com',
  'piggly wiggly': 'https://logo.clearbit.com/pigglywiggly.com',
  'brookshire': 'https://logo.clearbit.com/brookshires.com',
  'brookshires': 'https://logo.clearbit.com/brookshires.com'
};

// Brand colors for pharmacy badges (fallback)
const PHARMACY_COLORS = {
  'cvs': '#cc0000',
  'cvs pharmacy': '#cc0000',
  'walgreens': '#e31837',
  'walmart': '#0071dc',
  'rite aid': '#1e4096',
  'rite aid/walgreens': '#1e4096',
  'kroger': '#e31837',
  'costco': '#e31837',
  'target': '#cc0000',
  'publix': '#3d8b40',
  'safeway': '#e31837',
  'albertsons': '#0070c0',
  'food lion': '#009639',
  'giant': '#e31837',
  'giant eagle': '#00529b',
  'h-e-b': '#e31837',
  'heb': '#e31837',
  'meijer': '#d22630',
  'wegmans': '#008752',
  'sam\'s club': '#0060a9',
  'sams club': '#0060a9',
  'amazon pharmacy': '#ff9900',
  'amazon': '#ff9900',
  'harris teeter': '#d71921',
  'winn-dixie': '#e31837',
  'winn dixie': '#e31837',
  'fred meyer': '#e31837',
  'shoprite': '#ffd100',
  'hannaford': '#e31837',
  'good neighbor': '#00a651',
  'health mart': '#0072ce',
  'medical arts': '#2055df',
  'hematology': '#6b21a8',
  'oncology': '#6b21a8',
  'associates': '#4f46e5',
  'stop & shop': '#e21a2c',
  'stop and shop': '#e21a2c',
  'hy-vee': '#e31837',
  'hyvee': '#e31837',
  'price chopper': '#009639',
  'aldi': '#00005f',
  'duane reade': '#e31837',
  'acme': '#e31837',
  'vons': '#e31837',
  'jewel-osco': '#00529b',
  'genoa': '#00629b',
  'kinney': '#00529b',
  'medicine shoppe': '#00529b'
};

// Short abbreviations for fallback display
const PHARMACY_ABBREVIATIONS = {
  'cvs': 'CVS',
  'cvs pharmacy': 'CVS',
  'walgreens': 'Wg',
  'walmart': 'WM',
  'rite aid': 'RA',
  'rite aid/walgreens': 'RA',
  'kroger': 'Kr',
  'costco': 'CO',
  'target': 'TG',
  'publix': 'Px',
  'safeway': 'SW',
  'albertsons': 'Ab',
  'food lion': 'FL',
  'giant': 'Gt',
  'giant eagle': 'GE',
  'h-e-b': 'HEB',
  'heb': 'HEB',
  'meijer': 'Mj',
  'wegmans': 'Wg',
  'sam\'s club': 'SC',
  'sams club': 'SC',
  'amazon pharmacy': 'Az',
  'amazon': 'Az',
  'harris teeter': 'HT',
  'winn-dixie': 'WD',
  'winn dixie': 'WD',
  'fred meyer': 'FM',
  'shoprite': 'SR',
  'hannaford': 'Hf',
  'good neighbor': 'GN',
  'health mart': 'HM',
  'medicine shoppe': 'MS',
  'medical arts': 'MA',
  'hematology': 'HO',
  'oncology': 'ON',
  'stop & shop': 'SS',
  'stop and shop': 'SS',
  'hy-vee': 'HV',
  'hyvee': 'HV',
  'genoa': 'GH',
  'kinney': 'KD'
};

/**
 * Normalize pharmacy name for matching
 */
const normalizeName = (name) => {
  if (!name) return '';
  return name.toLowerCase().trim()
    .replace(/pharmacy/gi, '')
    .replace(/[#\d]+$/g, '')  // Remove trailing numbers like "CVS PHARMACY #1234"
    .replace(/\s+at\s+.*/gi, '') // Remove "at Target" etc
    .replace(/\s+inside\s+.*/gi, '') // Remove "Inside Target" etc
    .trim();
};

/**
 * Get pharmacy logo URL
 * @param {string} pharmacyName - Name of the pharmacy
 * @returns {string|null} - Logo URL or null if not found
 */
export const getPharmacyLogo = (pharmacyName) => {
  if (!pharmacyName) return null;
  
  const normalized = normalizeName(pharmacyName);
  
  // Direct match
  if (PHARMACY_LOGOS[normalized]) {
    return PHARMACY_LOGOS[normalized];
  }
  
  // Partial match - check if any key is in the name
  for (const [key, url] of Object.entries(PHARMACY_LOGOS)) {
    if (normalized.includes(key) || key.includes(normalized)) {
      return url;
    }
  }
  
  // Special case handling for "inside" stores
  const lowerName = pharmacyName.toLowerCase();
  if (lowerName.includes('cvs')) {
    return PHARMACY_LOGOS['cvs'];
  }
  if (lowerName.includes('target')) {
    return PHARMACY_LOGOS['target'];
  }
  if (lowerName.includes('walmart')) {
    return PHARMACY_LOGOS['walmart'];
  }
  
  return null;
};

/**
 * Get pharmacy brand color
 * @param {string} pharmacyName - Name of the pharmacy
 * @returns {string} - Brand color hex code
 */
export const getPharmacyColor = (pharmacyName) => {
  if (!pharmacyName) return '#2055df';
  
  const normalized = normalizeName(pharmacyName);
  
  // Direct match
  if (PHARMACY_COLORS[normalized]) {
    return PHARMACY_COLORS[normalized];
  }
  
  // Partial match
  for (const [key, color] of Object.entries(PHARMACY_COLORS)) {
    if (normalized.includes(key) || key.includes(normalized)) {
      return color;
    }
  }
  
  // Generate a consistent color based on name hash
  let hash = 0;
  for (let i = 0; i < pharmacyName.length; i++) {
    hash = pharmacyName.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash % 360);
  return `hsl(${hue}, 60%, 45%)`;
};

/**
 * Get short pharmacy name for display
 * @param {string} pharmacyName - Full pharmacy name
 * @returns {string} - Short name (2-3 letters)
 */
export const getPharmacyShortName = (pharmacyName) => {
  if (!pharmacyName) return 'RX';
  
  const normalized = normalizeName(pharmacyName);
  
  // Check known abbreviations
  for (const [key, abbr] of Object.entries(PHARMACY_ABBREVIATIONS)) {
    if (normalized.includes(key)) {
      return abbr;
    }
  }
  
  // Generate abbreviation from name - use first letter of first two words
  const words = pharmacyName.trim().split(/\s+/).filter(w => w.length > 0);
  if (words.length >= 2) {
    return (words[0][0] + words[1][0]).toUpperCase();
  }
  
  // Return first 2 letters capitalized
  return pharmacyName.substring(0, 2).toUpperCase();
};

export default { getPharmacyLogo, getPharmacyColor, getPharmacyShortName };